<template>
    <div>
        <div class="m-portlet left">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption" style="width: 100%">
                    <div class="m-portlet__head-title" style="width: 100%">
                        <h5>筛选条件</h5>
                    </div>
                </div>
            </div>
            <div class="m-portlet__body">
                <el-form>
                    <el-form-item>
                        <el-button style="float:left;" size="mini" type="success" @click="regularClick">新建测试</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="card right">
            <div class="card-body">
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th>测试规划</th>
                        <th>年级</th>
                        <th>课程</th>
                        <th>学科</th>
                        <th>开始日期</th>
                        <th>结束日期</th>
                        <th>操作</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in tableData">
                        <td>{{item.name}}</td>
                        <td>{{item.grade_name}}</td>
                        <td>{{item.course_name}}</td>
                        <td>{{item.subject_name}}</td>
                        <td>{{item.start_date}}</td>
                        <td>{{item.end_date}}</td>
                        <td>
                            <el-row :gutter="20">
                                <el-col :span="11">
                                    <el-button size="mini" @click="handleDetailExam(item.id)">查看测试详情</el-button>
                                </el-col>
                                <el-col :span="11">
                                    <el-button size="mini" @click="handleDeleteExam(item.id,item.name)">删除测试计划
                                    </el-button>
                                </el-col>
                            </el-row>
                        </td>
                    </tr>
                    <tr v-if="tableData.length==0">
                        <td colspan="8" class="text-center" style="font-size: 16px; ">
                            <i class="el-icon-time" style="height:10px;font-size:30px;margin-bottom: 18px"></i>
                            <br>
                            暂无数据
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="text-center m-t-10">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="10"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total">
                    </el-pagination>
                </div>

                <el-dialog title="定期设置" :visible.sync="visualRegular" width="600px" height="700px">
                    <el-form :model="regularForm" ref="batchNotifyForm"
                             label-width="80px">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="课程">
                                    <el-autocomplete label="课程"
                                                     v-model="regularForm.course_name"
                                                     :fetch-suggestions="queryCourseSearchAsync"
                                                     @select="handleSelect"
                                                     placeholder="输入课程关键字检索"
                                    >
                                    </el-autocomplete>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="学科">
                                    <el-autocomplete label="学科"
                                                     v-model="regularForm.subject_name"
                                                     :fetch-suggestions="querySubjectSearchAsync"
                                                     @select="handleSelect"
                                                     placeholder="输入学科关键字检索"
                                    >
                                    </el-autocomplete>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="年级">
                                    <el-autocomplete label="年级"
                                                     v-model="regularForm.grade_name"
                                                     :fetch-suggestions="queryGradeSearchAsync"
                                                     @select="handleSelect"
                                                     placeholder="输入年级关键字检索"
                                    >
                                    </el-autocomplete>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="班级">
                                    <el-select v-model="regularForm.class_ids" multiple placeholder="请选择班级">
                                        <el-option
                                                v-for="item in filter.classes"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="测试名称">
                                    <el-input v-model="regularForm.exam_name"></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :span="24">
                                <el-form-item label="开始日期">
                                    <el-date-picker
                                            v-model="regularForm.start_date"
                                            type="date"
                                            placeholder="请选择测试开始时间"
                                            value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="结束日期">
                                    <el-date-picker
                                            v-model="regularForm.end_date"
                                            type="date"
                                            placeholder="请选择测试结束时间"
                                            value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>

                        </el-row>
                        <el-form-item>
                            <el-button type="primary" @click="postExamPlan">提交</el-button>
                        </el-form-item>
                    </el-form>
                </el-dialog>


                <el-dialog title="测试列表" :visible.sync="examDetail" width="600px">
                    <table class="table table-striped">
                        <thead>
                        <tr>
                            <th>班级</th>
                            <th>开始日期</th>
                            <th>结束日期</th>
                            <th>负责老师</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in examList" style="height: 20px">
                            <td>{{item.className}}</td>
                            <td>{{item.start_date}}</td>
                            <td>{{item.end_date}}</td>
                            <td>{{item.teacherName}}</td>
                        </tr>
                        </tbody>
                    </table>
                    <div class="text-center m-t-10">
                        <el-pagination
                                @size-change="handleSizeChangeDetail"
                                @current-change="handleCurrentChangeDetail"
                                :current-page="detailCurrentPage"
                                :page-sizes="[5, 10, 15, 20]"
                                :page-size="5"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="detailTotal">
                        </el-pagination>
                    </div>
                </el-dialog>
            </div>
        </div>
        <!--<table class="table" v-loading="loading">-->
        <!--<thead>-->
        <!--<tr>-->
        <!--<th>机构</th>-->
        <!--<th>考试</th>-->
        <!--<th>年级</th>-->
        <!--<th>开始时间</th>-->
        <!--<th v-if="powers.includes(34)">操作</th>-->
        <!--</tr>-->
        <!--</thead>-->
        <!--<tbody>-->
        <!--<tr v-for="item in organizationServiceExams">-->
        <!--<td>{{item.organization_service.name}}</td>-->
        <!--<td>{{item.name}}</td>-->
        <!--<td>{{item.grade.name}}</td>-->
        <!--<td>{{item.date}}</td>-->

        <!--<td v-if="powers.includes(34)"> <el-button size="mini" @click="handleOrganizationServiceExamInformation(item.id)">查看详情</el-button></td>-->
        <!--</tr>-->
        <!--</tbody>-->
        <!--</table>-->


    </div>
</template>

<script>
    import store from '@/store'

    export default {
        name: "students-list",
        data() {
            return {
                regularForm: {
                    type: 1,
                    start_date: '',
                    end_date: '',
                    class_ids: [],
                    exam_name: '',
                    course_name: '',
                    subject_name: '',
                    grade_name: '',
                },
                singleForm: {
                    type: 2,
                    start_day: '',
                    course_id: '',
                    class_ids: [],
                    subject_id: '',
                },
                examDetail: false,
                visualRegular: false,
                visualSingle: false,
                tableData: new Object(),
                examList: [],
                loading: 'true',
                tempList_id: 0,
                organizationServiceExams: {},
                currentPage: 1,
                currentPageSize: 10,
                detailCurrentPage: 1,
                detailCurrentPageSize: 5,
                total: 1,
                detailTotal: 0,
                filter: {
                    course_name: '',
                    subject_name: '',
                    grade_name: '',
                    classes: [],
                    courses: [],
                    subjects: [],
                }
            }
        },
        created() {
            //this.handleIndexExamPlan();
            //this.handleEcho();
            //this.handleListen();
        },
        computed: {
            powers() {
                return this.$store.state.config.powers;
            }
        },
        destroyed() {
            this.$Echo.leave('examPlan');
        },
        mounted() {
            this.$nextTick(() => {
                this.loading = false
            })
        },
        methods: {
            handleListen() {
                this.$Echo.private('examPlan')
                    .listen('.examPlanStore', (e) => {
                        let arr = Object.keys(this.tableData);
                        if (arr.length < 10) {
                            this.$set(this.tableData, e.examPlan.id, e.examPlan);
                        }
                        this.total = this.total + 1;
                    }).listen('.examPlanDestroy', (e) => {
                    this.$delete(this.tableData, e.examPlan_id);
                    this.total = this.total - 1;
                })
            },
            handleIndexDetail(currentPage = 1, currentPageSize = 5) {
                this.$axios.get(store.state.server + '/exam/plan/detail?plan_id=' + this.tempList_id + '&' + localStorage.baseUrl + '&detailCurrentPage=' + currentPage + '&detailCurrentPageSize=' + currentPageSize).then((response) => {
                    if (response.data.status === 'success') {
                        this.examList = response.data.tableData;
                        this.detailTotal = response.data.total;
                    }
                }).catch((error) => {
                })
            },
            handleDetailExam(id) {
                this.tempList_id = id;
                this.$axios.get(store.state.server + '/exam/plan/detail?plan_id=' + id + '&' + localStorage.baseUrl + '&detailCurrentPage=' + this.detailCurrentPage + '&detailCurrentPageSize=' + this.detailCurrentPageSize).then((response) => {
                    if (response.data.status === 'success') {
                        this.examList = response.data.tableData;
                        this.detailTotal = response.data.total;
                        this.examDetail = true;
                    }
                }).catch((error) => {
                })
            },
            handleDeleteExam(id, name) {
                this.$confirm('是否删除“' + name + '”?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios.delete(store.state.server + '/exam/plan/' + id + '?' + localStorage.baseUrl).then((response) => {
                        if (response.data.status === 'success') {
                            this.$notify({
                                title: '成功',
                                message: name + '已删除',
                                type: 'success'
                            });
                        }
                    }).catch((error) => {
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });


            },
            postExamPlan() {
                if (this.regularForm.exam_name === '') {
                    this.$notify({
                        title: '错误',
                        message: '请填写测试名称',
                        type: 'error'
                    });
                } else {
                    if ((this.regularForm.start_date === '') || (this.regularForm.end_date === '') || ((new Date(this.regularForm.start_date)) > (new Date(this.regularForm.end_date)))) {
                        this.$notify({
                            title: '错误',
                            message: '请填写并规范日期',
                            type: 'error'
                        });
                    } else {
                        if (this.regularForm.class_ids.length === 0) {
                            this.$confirm('确认不选择班级，默认满足条件的所有班级?', '提示', {
                                StartReturn: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                this.$axios.post(store.state.server + '/exam/plan' + '?' + localStorage.baseUrl, this.regularForm).then((response) => {
                                    if (response.data.status === 'success') {
                                        this.$notify({
                                            title: '成功',
                                            message: '测试发布成功',
                                            type: 'success'
                                        });
                                        this.regularForm.start_date = '';
                                        this.regularForm.end_date = '';
                                        this.regularForm.class_ids = [];
                                        this.regularForm.exam_name = '';
                                        this.regularForm.course_name = '';
                                        this.regularForm.subject_name = '';
                                        this.regularForm.grade_name = '';
                                        this.visualRegular = false;
                                    }
                                }).catch((error) => {
                                })
                            }).catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: '已取消'
                                });
                            });
                        } else {
                            this.$axios.post(store.state.server + '/exam/plan' + '?' + localStorage.baseUrl, this.regularForm).then((response) => {
                                if (response.data.status === 'success') {
                                    this.$notify({
                                        title: '成功',
                                        message: '测试发布成功',
                                        type: 'success'
                                    });
                                    this.regularForm.start_date = '';
                                    this.regularForm.end_date = '';
                                    this.regularForm.class_ids = [];
                                    this.regularForm.exam_name = '';
                                    this.regularForm.course_name = '';
                                    this.regularForm.subject_name = '';
                                    this.regularForm.grade_name = '';
                                    this.visualRegular = false;
                                }
                            }).catch((error) => {
                            })
                        }
                    }
                }
            },
            queryCourseSearchAsync(queryString, callback) {

                this.handleSelect();

                let list = [{}];
                this.$axios.get(store.state.server + '/exam/plan/courseSearch?courseKeyName=' + queryString).then((response) => {
                    if (response.data.status === 'success') {
                        for (let i of response.data.courses) {
                            i.value = i.name;
                        }
                        list = response.data.courses;
                        callback(list);
                    }
                }).catch((error) => {
                })
            },

            queryGradeSearchAsync(queryString, callback) {

                this.handleSelect();

                let list = [{}];
                this.$axios.get(store.state.server + '/exam/plan/gradeSearch?gradeKeyName=' + queryString).then((response) => {
                    if (response.data.status === 'success') {
                        for (let i of response.data.grades) {
                            i.value = i.name;
                        }
                        list = response.data.grades;
                        callback(list);
                    }
                }).catch((error) => {
                })
            },

            querySubjectSearchAsync(queryString, callback) {
                this.handleSelect();
                let list = [{}];
                this.$axios.get(store.state.server + '/exam/plan/subjectSearch?subjectKeyName=' + queryString).then((response) => {
                    if (response.data.status === 'success') {
                        for (let i of response.data.subjects) {
                            i.value = i.name;
                        }
                        list = response.data.subjects;
                        callback(list);
                    }
                }).catch((error) => {
                })
            },
            handleSelect() {
                this.$axios.get(store.state.server + '/exam/plan/classSearch?subject_name=' + this.regularForm.subject_name + '&course_name=' + this.regularForm.course_name + '&grade_name=' + this.regularForm.grade_name).then((response) => {
                    if (response.data.status === 'success') {
                        this.filter.classes = response.data.classes;
                    }
                }).catch((error) => {
                })
            },

            regularClick() {
                this.$Win.openModal('/createOrganizationServiceExam', 900, 500, '新建机构考试');
            },

            handleEcho() {
                this.$Echo.private('organizationServiceExam')
                    .listen('.organizationServiceExamStore', (e) => {
                        this.$set(this.organizationServiceExams, e.organizationServiceExam.id, e.organizationServiceExam);
                    })
                    .listen('.organizationServiceExamDestroy', (e) => {
                        this.$delete(this.organizationServiceExams, e.organizationServiceExam_id)

                    })
                    .listen('.organizationServiceExamUpdate', (e) => {
                        this.$set(this.organizationServiceExams, e.organizationServiceExam.id, e.organizationServiceExam);
                    });
            },
            handleIndexExamPlan(currentPage = 1, currentPageSize = 10) {
                this.$axios.get(store.state.server + '/exam/plan?currentPage=' + currentPage + '&currentPageSize=' + currentPageSize + '&' + localStorage.baseUrl).then(response => {
                    if (response.data.status === 'success') {
                        this.tableData = response.data.tableData;
                        this.total = response.data.total;
                    }
                })
            },

            handleSizeChangeDetail(val) {
                this.detailCurrentPageSize = val;
                this.handleIndexDetail(this.detailCurrentPage, this.detailCurrentPageSize)
            },
            handleCurrentChangeDetail(val) {
                this.detailCurrentPage = val;
                this.handleIndexDetail(this.detailCurrentPage, this.detailCurrentPageSize)
            },

            handleSizeChange(val) {
                this.currentPageSize = val;
                this.handleIndexExamPlan(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.handleIndexExamPlan(this.currentPage, this.currentPageSize)
            },
        }
    }
</script>

<style scoped>

    .left {
        float: left;
        width: 220px;
    }

    .right {
        margin-left: 225px;
    }

    .table th, .table td {
        padding: 10px 20px;
        border-bottom: 1px solid rgba(234, 243, 253, .9);
    }
</style>
